
  import { defineComponent, PropType } from 'vue';

  import { TFilter } from '@/common/components/redesigned/Filter/types/filter';
  import {
    TableEventTypes,
    TableSortTypes,
    TSortParams,
    TTableEventConfigs,
  } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TStorePaths } from '@/common/types/storePaths';

  import { SIGNIFICANT_EVENT_LEGEND } from '../../constants/dashboards';
  import { EVENTS_VES_ACTIONS_NAME, EVENTS_VES_GETTERS_NAME, EVENTS_VES_MUTATIONS_NAME } from '../../store/events/name';
  import { TDashboardsTableFilter, TDashboardsTableItem, TEventsTableFilter } from '../../types/dashboards';
  import { getEventCardRoute } from '../../utils/router';
  import EventsBaseTable from './EventsBaseTable.vue';
  import { getPlannedEventColumns } from './eventsTableColumns';
  import EventsTableFilters from './EventsTableFilters.vue';
  import { getEventsTableParams } from './eventsTableParams';

  const DEFAULT_SORT: TSortParams = { sortColumn: 'startEventDate', sortOrder: TableSortTypes.ASCEND };

  export default defineComponent({
    name: 'PlannedEventsTable',
    components: { EventsBaseTable, EventsTableFilters },
    emits: ['changeFilter'],
    props: {
      params: {
        type: Object as PropType<Partial<TDashboardsTableFilter>>,
        default: () => ({}),
      },
      hideSubjectFilter: {
        type: Boolean,
        default: false,
      },
      isDatesColumnFirst: {
        type: Boolean,
        default: false,
      },
      hideCountryFilter: {
        type: Boolean,
        default: false,
      },
    },
    data(): { storePaths: TStorePaths; filter: TEventsTableFilter; significantEventLegend: string } {
      return {
        significantEventLegend: SIGNIFICANT_EVENT_LEGEND,
        storePaths: {
          action: EVENTS_VES_ACTIONS_NAME.getEventsTable,
          mutation: EVENTS_VES_MUTATIONS_NAME.setEventsTable,
          getter: EVENTS_VES_GETTERS_NAME.getEventsTable,
        },
        filter: {},
      };
    },
    computed: {
      defaultSort(): TSortParams {
        return DEFAULT_SORT;
      },
      columns() {
        return getPlannedEventColumns(this.isDatesColumnFirst);
      },
      tableParams(): TFilter {
        return getEventsTableParams(false, this.params, this.filter);
      },
      eventConfigs(): TTableEventConfigs<TDashboardsTableItem> {
        return [
          {
            type: TableEventTypes.ROW_CLICK,
            func: (item) => this.$router.push(getEventCardRoute(item.id, false)),
          },
        ];
      },
    },
    methods: {
      onFilterChange(filter: TEventsTableFilter) {
        this.filter = filter;
        this.$emit('changeFilter', filter);
      },
    },
  });
